import { keyframes, styled } from "solid-styled-components";

const pulse = keyframes(`
  0% {
    transform: scale(1);
  }
  50%{
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`);

export const PulsingColoredCircle = styled.div<{ delay: number; opacity: string; disabled?: boolean }>`
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  ${({ disabled }) => (disabled ? "filter: saturate(0); cursor: not-allowed;" : "cursor: pointer;")}
  background: ${({ theme }) => theme?.button?.background}${({ opacity }) => opacity};
  color: ${({ theme }) => theme?.button?.color};
  animation: infinite 3s ${pulse} ${({ delay }) => delay}s;
  transition: all 0.5s;
  &:hover {
    width: 100%;
    height: 100%;
  }
  & > div {
    width: 70%;
    height: 70%;
    pointer-events: none;
  }
`;
